import { Box, Button, Typography } from "@mui/material";
import { BuzzfeedResult } from "../../../../../manifest/models/quiz.models";
import "./quiz-result.component.css";

export interface QuizResultProps extends BuzzfeedResult {
  onResultConfirmed: () => void;
  includeButton?: boolean;
}

export function QuizResult(props: QuizResultProps) {
  return (
    <Box
      id={props.id}
      className="quiz-result-container"
      sx={{ margin: "10px" }}
    >
      <Typography
        variant="h4"
        sx={{
          backgroundColor: "white",
          borderRadius: "12px",
          margin: "0 30px",
        }}
        id={`${props.id}-title`}
      >
        {props.name}
      </Typography>
      <Typography
        id={`${props.id}-description`}
        className="quiz-result-description"
        variant="body1"
      >
        {props.description}
      </Typography>

      <img src={props.image} className="quiz-result-image" />
      <Button
        sx={{
          display: (props.includeButton ?? true) ? "unset" : "none",
        }}
        id={`${props.id}-result-confirm`}
        variant="contained"
        onClick={props.onResultConfirmed}
      >
        Okay
      </Button>
    </Box>
  );
}
